const path = require('path')
const { name } = require('./package')

// 增加 EventEmitter 默认的最大监听器数量，防止代理规则过多导致 MaxListenersExceededWarning
require('events').EventEmitter.defaultMaxListeners = 55

const proxy = require('common-micro/src/configs/proxy.js')

function resolve(dir) {
  return path.join(__dirname, dir)
}

const port = 5700 // dev port

module.exports = {
  css: {},
  transpileDependencies: ['axios', 'jspdf', 'fast-png', 'iobuffer'],
  lintOnSave: process.env.NODE_ENV !== 'production',
  publicPath: '/',
  productionSourceMap: true,
  runtimeCompiler: false,
  /**
   * You will need to set publicPath if you plan to deploy your site under a sub path,
   * for example GitHub Pages. If you plan to deploy your site to https://foo.github.io/bar/,
   * then publicPath should be set to "/bar/".
   * In most cases please use '/' !!!
   * Detail: https://cli.vuejs.org/config/#publicpath
   */
  outputDir: 'dist',
  filenameHashing: true,
  // tweak internal webpack configuration.
  // see https://github.com/vuejs/vue-cli/blob/dev/docs/webpack.md
  devServer: {
    host: '0.0.0.0',
    hot: true,
    disableHostCheck: true,
    port,
    overlay: {
      warnings: true,
      errors: true
    },
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': true
    },
    proxy
  },
  chainWebpack: (config) => {
    // 除非在IDE中配置对应的配置文件，否则虽然路径有效，但在coding时IDE会识别不了，不方便文件间的跳转操作。
    // 所以用 '@/'的形式就已经很方便了，下面的可以不用
    config.resolve.alias
      .set('@$', resolve('src'))
      .set('@apis', resolve('src/apis'))
      .set('@assets', resolve('src/assets'))
      .set('@comp', resolve('src/components'))
      .set('@views', resolve('src/views'))
      .set('@micro', resolve('../common-micro'))
      .set('@kc', resolve('../kjqk-commons/src'))
      .set('@kcAPI', resolve('../kjqk-commons/src/api'))
      .set('@kcStatic', resolve('../kjqk-commons/src/static'))
      .set('@main', resolve('../main'))

    // 配置 postcss-loader 使用项目目录下的配置文件
    const arr = ['vue-modules', 'vue', 'normal-modules', 'normal']
    arr.forEach((rule) => {
      config.module
        .rule('css')
        .oneOf(rule)
        .use('postcss-loader')
        .tap((options) => {
          return {
            ...options,
            postcssOptions: {
              config: {
                path: __dirname
              }
            }
          }
        })
    })

    // 配置 svg-sprite-loader
    config.module
      .rule('svg')
      .exclude.add(resolve('src/assets/img/svgIcon'))
      .end()
    config.module
      .rule('icons')
      .test(/\.svg$/)
      .include.add(resolve('src/assets/img/svgIcon'))
      .end()
      .use('svg-sprite-loader')
      .loader('svg-sprite-loader')
      .options({
        symbolId: 'icon-[name]'
      })
      .end()
  },
  // 自定义webpack配置
  configureWebpack: {
    output: {
      // 把子应用打包成 umd 库格式
      library: `${name}-[name]`,
      libraryTarget: 'umd',
      jsonpFunction: `webpackJsonp_${name}`
    },
    resolve: {
      symlinks: true
    }
  }
}
